import {
  AccountableUsers,
  Header,
  AddUser,
  AddUserTitle,
  ActualUser,
  Avatar,
  CloseDiv,
} from './styles';
import Close from '../../../assets/icons/Close';
import ProfileCircle from '../../../assets/icons/profileCircle';
import { useRef, useState } from 'react';
import { SearchInput } from './SearchInput';
import { useOutsideDrop } from '../../../hooks/useOutsideDrop';
import { trackPromise, usePromiseTracker } from 'react-promise-tracker';
import { useDispatch } from 'react-redux';

// import ReactLoading from 'react-loading';

const Accountable = ({
  subtitle = 'Responsável',
  list,
  id,
  open,
  accountable,
  style,
  handles,
  callback = () => null,
}) => {
  const [openSearch, setOpenSearch] = useState(false);
  const wrapperRef = useRef(null);

  const dispatch = useDispatch();

  const clearInput = () => setOpenSearch(false);

  useOutsideDrop(wrapperRef, clearInput);

  const { promiseInProgress: accLoading } = usePromiseTracker({
    area: 'update-acc',
  });

  const {
    updateAcc: handleUpdateAccountable,
    removeAcc: handleRemoveAccountable,
  } = handles;

  async function updateAccountable(user) {
    await trackPromise(
      dispatch(
        handleUpdateAccountable({
          id,
          userId: user._id,
        })
      ).then((res) => {
        const payload = res.payload;
        callback(payload);
        setOpenSearch(false);
      }),
      'update-acc'
    );
  }
  async function removeAccountable() {
    await trackPromise(
      dispatch(
        handleRemoveAccountable({
          id,
        })
      ).then((res) => {
        const payload = res.payload;
        callback(payload);
        setOpenSearch(false);
      }),
      'update-acc'
    );
  }

  return (
    <AccountableUsers ref={wrapperRef} id={'accountable-' + id} style={style}>
      {subtitle ? (
        <Header>
          <span>{subtitle}</span>
        </Header>
      ) : null}

      <AddUser
        onClick={(e) => {
          e.stopPropagation();
          setOpenSearch(true);
        }}
      >
        {!openSearch && !accountable ? (
          <>
            <ProfileCircle height="1.7592rem" />
            <AddUserTitle>+ Adicionar Responsável</AddUserTitle>
          </>
        ) : openSearch && !accountable ? (
          <SearchInput
            open={openSearch && !accountable}
            list={list}
            wrapperRef={wrapperRef}
            update={updateAccountable}
            onClose={() => setOpenSearch(false)}
          />
        ) : (
          <ActualUser>
            <Avatar src={accountable?.avatarURL} />
            <span>{accountable?.username}</span>
            <CloseDiv>
              <Close
                onClick={(e) => {
                  e.stopPropagation();
                  removeAccountable();
                }}
              />
            </CloseDiv>
          </ActualUser>
        )}
      </AddUser>
    </AccountableUsers>
  );
};

export default Accountable;
